export class ListWorkspacesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "workspaces",
            "baseName": "workspaces",
            "type": "Array<Workspace>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListWorkspacesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
